'use client';

import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { getCookie } from '../helpers/cookies';
function useCookieWatcher(cookieName) {
  var intervalTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var _useState = useState(() => {
      return getCookie(cookieName);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    cookieValue = _useState2[0],
    setCookieValue = _useState2[1];
  useEffect(() => {
    var interval = setInterval(() => {
      var currentValue = getCookie(cookieName);
      if (currentValue !== cookieValue) {
        setCookieValue(currentValue);
      }
    }, intervalTime);
    return () => clearInterval(interval);
  }, [cookieName, cookieValue]);
  return cookieValue;
}
export default useCookieWatcher;